<ion-content scroll-y="false">
  <ion-grid>
    <ion-row class="ion-margin-vertical">
      <ion-col>
        <div class="ion-text-center bold">{{user.fullname}}</div>
      </ion-col>
    </ion-row>
    @if (user.fr_telcontactappliprestas && platform.is('mobile') && !platform.is('tablet')) {
      <ion-row class="ion-justify-content-center">
        <ion-col size="12">
          <a [href]="'tel:' + user.fr_telcontactappliprestas">
            <ion-button fill="block" class="custom">Appeler</ion-button>
          </a>
        </ion-col>
      </ion-row>
    }
    <ion-row class="ion-justify-content-center">
      <ion-col size="12">
                <a class="ion-color-primary w-100" [href]="'https://teams.microsoft.com/l/chat/0/0?users='+user.internalemailaddress" target="_blank">
                    <ion-button fill="block" class="custom">Contacter via Teams</ion-button>
                </a>
            </ion-col>
        </ion-row>
        <ion-row>
        </ion-row>
    </ion-grid>
</ion-content>
<ion-footer>
    <ion-grid fixed="true">
        <ion-row class="bas">
            <ion-col size="12" class="text-center">
                <ion-button color="dark" fill="solid" expand="block" (click)="close()">Retour</ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-footer>
